import { useEffect, useState } from "react";
import { ImageOff } from "lucide-react";
import { api } from "../lib/api";

export const AuthImage = ({ src, client = api, className = "", alt = "", testid }) => {
  const [url, setUrl] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let href = null;
    let alive = true;
    setUrl(null);
    setFailed(false);
    client.get(src, { responseType: "blob" })
      .then((r) => { if (alive) { href = URL.createObjectURL(r.data); setUrl(href); } })
      .catch(() => alive && setFailed(true));
    return () => { alive = false; if (href) URL.revokeObjectURL(href); };
  }, [src, client]);

  if (failed)
    return <div data-testid={testid} className={`flex items-center justify-center bg-gray-100 text-gray-400 ${className}`}><ImageOff className="h-5 w-5" /></div>;
  if (!url) return <div data-testid={testid} className={`animate-pulse bg-gray-200 ${className}`} />;
  return <img data-testid={testid} src={url} alt={alt} className={`object-cover ${className}`} />;
};
